import React from 'react';
import { DATA_HOOK } from '../../ListItemAction.constants';
import { classes, st } from '../../ListItemAction.st.css.js';
export const Icon = ({ suffixIcon, size, subtitle, }) => {
    return React.cloneElement(suffixIcon, {
        size: size === 'medium' ? 24 : 18,
        className: st(classes.suffixIcon, { subtitle: Boolean(subtitle) }),
        'data-hook': DATA_HOOK.suffixIcon,
    });
};
//# sourceMappingURL=SuffixIcon.js.map